export function typeIsVast(creativeType?: string): boolean {
  return ['MAGNITE', 'VAST_VIDEO', 'DRAX', 'BRIGHTLINE', 'INNOVID'].includes(creativeType || '');
}
